
function initialState() {
    return {
        err: []
    }
}

export default {
    state: initialState(),
    getters: {
        ERROR_DATA: state => state.err
    },
    mutations: {
        SET_ERROR_DATA(state, payload) {
            state.err = payload;
        },
        RESET_ERROR_DATA(state) {
            const s = initialState();
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        }
    },
    actions: {
        SET_ERROR_DATA: ({commit}, data) => {
            commit('SET_ERROR_DATA', data);
        },
        RESET_ERROR_DATA: ({commit}) => {
            commit('RESET_ERROR_DATA');
        },
    }
}
